import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/core/components/tour-step.tsx
var TourStep = ({ title, description }) => /* @__PURE__ */ jsxs("div", {
	className: "text-center",
	children: [/* @__PURE__ */ jsx("h3", {
		className: "text-h3",
		children: title
	}), /* @__PURE__ */ jsx("p", { children: description })]
});
//#endregion
export { TourStep };
